import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const popoverContent = style(
  {
    minWidth: '320px',
    maxWidth: '480px',
    maxHeight: '400px',
    overflowY: 'auto',
  },
  'segment-preview-popover-content',
);

export const conditionItem = style(
  {
    borderRadius: themeVars.radius['2'],
  },
  'segment-preview-condition-item',
);

export const nestedGroup = style(
  {
    marginLeft: themeVars.space['050'],
  },
  'segment-preview-nested-group',
);

export const triggerContainer = style(
  {
    cursor: 'help',
    display: 'inline-flex',
    alignItems: 'center',
    gap: themeVars.space['050'],
  },
  'segment-preview-trigger-container',
);

export const segmentIcon = style(
  {
    flexShrink: 0,
  },
  'segment-preview-segment-icon',
);

export const loadingContainer = style(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: themeVars.space['600'],
    gap: themeVars.space['200'],
  },
  'segment-preview-loading-container',
);

export const footerLink = style(
  {
    textDecoration: 'underline',
    ':hover': {
      textDecoration: 'none',
    },
  },
  'segment-preview-footer-link',
);
